import React, { useState, useEffect, use } from "react";
import Order from "../components/Order";
import TopicList from "../components/TopicList";
import MessageForm from "../components/MessageForm";

const Case = ({ selectedProjectData, topics,
    activeComponent, setActiveComponent,
    setSelectedTopic, ordersDetails }) => {
    // const [isSidebarVisible, setIsSidebarVisible] = useState(false);

    return (
        <>
            <div className="wrapper" style={{overflowY:"auto"}}>
                <Order selectedProjectData={selectedProjectData} />
                <TopicList topics={topics}
                    activeComponent={activeComponent} setActiveComponent={setActiveComponent}
                    setSelectedTopic={setSelectedTopic}
                />
            </div>
        </>
    )
}

export default Case;


                // <MessageForm
                //     isSidebarVisible={isSidebarVisible}
                //     setIsSidebarVisible={setIsSidebarVisible}
                //     selectedProjectData={selectedProjectData}
                // />